export const editUserPayload = (payload) => {
  const result = payload;
  result['regional'] = result.regional === 'All' ? '': result.regional;
  result['samId'] = result.samId === 'All' ? '': result.samId;
  result['sbmId'] = result.sbmId === 'All' ? '': result.sbmId;
  delete result['createdAt'];
  delete result['regionalName'];
  delete result['samName'];
  delete result['sbmName'];
  delete result['roleName'];
  delete result['password'];
  delete result['regionalId'];
  delete result['userId'];
  delete result['cities'];
  delete result['cityId'];

  return result;
};


export const addUserPayload = (payload) => {
  const result = payload;
  result['regional'] = payload.regional;
  result['samId'] = payload.samId;
  result['sbmId'] = payload.sbmId;

  return result;
};

